import './App.css';
import { GlobalStateProvider } from './Contexts/GlobalStateContext';
import Router from './route';
import ErrorModal from './Components/ErrorModal/ErrorModal';
import Loading from './Components/Loading/Loading';
import NetworkErrorModal from './Components/NetworkErrorModal/NetworkErrorModal';
import { ClientUserStateProvider } from './Contexts/ClientUserStateContext';

const App = () => {
  return (
    <GlobalStateProvider>
      <ClientUserStateProvider>
        <Router />
      </ ClientUserStateProvider>
      <Loading />
      <ErrorModal />
      <NetworkErrorModal />
    </GlobalStateProvider>
  );
}

export default App;
